export default {"src":"/_next/static/media/fire-icon.214e9970.svg","height":513,"width":512};